export class ToggleBrickDefinitionMenuOpeningStateForInnerWallBrick {
   public static readonly type = '[InnerWallBrick] Toggle brick definition menu opening state';

   constructor(public brickInstanceId: string) {}
}

export class ChangeBrickDefinitionMenuOpeningStateForInnerWallBrick {
   public static readonly type = '[InnerWallBrick] Change brick definition menu opening state';

   constructor(public brickInstanceId: string, public isOpen: boolean) {}
}

export class RemoveBrickFromInnerWallBrick {
   public static readonly type = '[InnerWallBrick] Remove from inner wall brick';

   constructor(public brickWallInstanceId: string, public brickInstanceIdToRemove: string) {}
}

export class InnerBrickWallSelectedInTabBrick {
   public static readonly type = '[InnerWallBrick] Inner brick wall selected in tab brick';

   constructor(public innerBrickWallBrickInstanceId: string) {}
}
